import { Box, Flex, Text, theme } from '@/components';
import {
  type WorkflowApprovalModel,
  WorkflowApprovalStateTypeLabelModifier,
} from '@/features/workflow/models/approval';
import { dateFormat } from '@/utils';
import type { FC } from 'react';
import type { z } from 'zod';

type Props = Pick<
  z.infer<typeof WorkflowApprovalModel>,
  'state' | 'approvedAt'
>;

export const ApprovalStatusSignifier: FC<Props> = ({ state, approvedAt }) => {
  const { token } = theme.useToken();

  const getDotColor = () => {
    switch (state) {
      case 'approved':
        return token.colorSuccess;

      case 'rejected':
        return token.colorError;

      case 'reviewing':
        return token.colorTextTertiary;
    }
  };

  return (
    <Flex align="center" gap={8}>
      <Box
        width={6}
        height={6}
        borderRadius="50%"
        backgroundColor={getDotColor()}
      />
      <Text
        text={WorkflowApprovalStateTypeLabelModifier[state]}
        variant="body"
        weight="regular"
      />
      {state === 'approved' && approvedAt && (
        <Text
          text={dateFormat({
            datetime: approvedAt,
            format: 'YYYY/MM/DD HH:mm',
          })}
          color="secondary"
          variant="footnote"
          weight="regular"
        />
      )}
    </Flex>
  );
};
